import React from 'react';
import * as Styled from '../../carousel-lite.styled';
export var CarouselPips = function (_a) {
    var slides = _a.slides, shouldShowPips = _a.shouldShowPips, currentSlideIndex = _a.currentSlideIndex, handleSlideMove = _a.handleSlideMove;
    if (!shouldShowPips)
        return null;
    return (React.createElement(Styled.CarouselPips, { role: "group", "aria-label": "Slide controls" }, slides.map(function (_, index) {
        var isActive = index === currentSlideIndex;
        var slidePlus1 = index + 1;
        var pipText = isActive ? "Currently viewing slide ".concat(slidePlus1) : "Go to slide ".concat(slidePlus1);
        var handlePipSlideClick = function (event, index) {
            event.stopPropagation();
            event.preventDefault();
            if (isActive)
                return;
            handleSlideMove(index);
        };
        return (React.createElement(Styled.CarouselPip, { key: "carousel-pip-".concat(index), "aria-disabled": isActive, onClick: function (event) { return handlePipSlideClick(event, index); }, isActive: isActive },
            React.createElement(Styled.VisuallyHidden, null, pipText)));
    })));
};
